import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/TweetSection.css';

function TweetSection() {
  const { t } = useTranslation();
  
  return (
    <section className="tweet-section">
      <div className="tweet-container">
        <div className="tweet-content">
          <div className="text-label hewwo">
            <div className="text-wrapper">{t('tweet.hello')}</div>
          </div>
          
          <div className="text-label symbols">
            <div className="text-wrapper">{t('tweet.symbols')}</div>
          </div>
          
          <div className="text-label skyris">
            <div className="i-m-skyris">{t('tweet.imBobo')}</div>
          </div>
          
          <div className="text-label tweet-you">
            <p className="nice-to-tweet-you">
              {t('tweet.niceTweet')}
            </p>
          </div>
          
          <div className="text-label at-symbol">
            <div className="text-wrapper">@</div>
          </div>
          
          <div className="tweet-description">
            <p>
              {t('tweet.description')}
            </p>
          </div>
        </div>
        
        <div className="bobo-image-container">
          <img src="/images/page5/body.png" alt="BOBO AI pet" className="bobo-image" />
        </div>
      </div>
    </section>
  );
}

export default TweetSection; 